import angular = require('angular');
import { EnumService } from '../../../../../../app.common/modules/common/services/enum.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { ClassificationCategoriesBase } from '../../../../../../app.retailer.common/modules/categories/classification-categories-base.component';
import { ClassificationCategoriesService } from '../../../../../../app.retailer.common/modules/categories/classification-categories.service';

class SelectProductClassificationCategories extends ClassificationCategoriesBase {
    public static $inject = ['classificationCategoriesService', 'popupService', '$timeout', 'enumService'];
    public languageId: number;

    constructor(
        classificationCategoriesService: ClassificationCategoriesService,
        popupService: PopupService,
        $timeout: ng.ITimeoutService,
        enumService: EnumService
    ) {
        super(classificationCategoriesService, popupService, $timeout, enumService);
    }

    public async getCategoriesTree() {
        return await this.classificationCategoriesService.getTree(this.languageId);
    }
}

angular
    .module('app.retailes.common')
    .component('selectProductClassificationCategories', {
        template: require('./select-product-classification-categories.component.html'),
        controller: SelectProductClassificationCategories,
        controllerAs: 'vm',
        bindings: {
            selectedCategories: '<',
            businessType: '<',
            singleSelect: '<',
            waiting: '<',
            errors: '=',
            externalConfirm: '@',
            changeCategory: '&',
            hideTitles: '<',
            isDisabled: '<',
            languageId: '<'
        }
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/shared/select-product-category/select-product-classification-categories/select-product-classification-categories.component.ts